function moveItem<T>(arr: T[], from: number, to: number): T[] {
  const newArray = [...arr];
  const item = newArray.splice(from, 1)[0];
  newArray.splice(to, 0, item);
  return newArray;
}

export function moveElementInList<T extends {
  id: string }>(list: T[], sourceId: string | null | undefined, targetId: string | null | undefined): T[] {
  if (!sourceId || !targetId) {
    return list;
  }

  const sourceIndex = list.findIndex(element => element.id === sourceId);
  const targetIndex = list.findIndex(element => element.id === targetId);

  if (targetIndex === -1 || sourceIndex === -1) {
    return list;
  }

  return moveItem(list, sourceIndex, targetIndex);
}
